import { Theme } from '@mui/material/styles'
import { SxProps, alpha } from '@mui/system'
import { grey } from '@mui/material/colors';

interface CalendarDynamicProps {
  top?: number
  shadedHeight?: number
  backgroundColor?: string
  color?: string;
}

interface StyleProps {
  header: SxProps<Theme>
  seeMore: SxProps<Theme>
  customTitle: SxProps<Theme>
  monthBody: SxProps<Theme>
  monthHeader: SxProps<Theme>
  monthCell: SxProps<Theme>
  layoutTooltip: SxProps<Theme>
  saveBtnForm: SxProps<Theme>
  linkBtn: SxProps<Theme>
  headerContainer: SxProps<Theme>
  content: SxProps<Theme>
  contentContainer: SxProps<Theme>
  text: SxProps<Theme>
  title: SxProps<Theme>
  icon: SxProps<Theme>
  contentItemIcon: SxProps<Theme>
  grayIcon: SxProps<Theme>
  colorfulContent: SxProps<Theme>
  callToActionBtn: SxProps<Theme>
  lens: SxProps<Theme>
  textCenter: SxProps<Theme>
  dateAndTitle: SxProps<Theme>
  spaker: SxProps<Theme>
  description: SxProps<Theme>
  titleContainer: SxProps<Theme>
  container: SxProps<Theme>
  line: SxProps<Theme>
  circle: SxProps<Theme>
  nowIndicator: SxProps<Theme>
  shadedCell: SxProps<Theme>
  shadedPart: SxProps<Theme>
  appointment: SxProps<Theme>
  shadedAppointment: SxProps<Theme>
}

const calendarStyles = (theme: Theme, props: CalendarDynamicProps): StyleProps => ({
    header: {
        borderBottom: '1px solid  #C7CCD1',
        padding: '16px 0',
        marginTop: 6,
        marginBottom: 3,
        "& h5": {
            [theme.breakpoints.down('sm')]: {
                fontSize: '1.5rem',
                fontWeight: 500,
            },
        },
        "& p": {
            whiteSpace: "nowrap",
        }
    },
    seeMore: {
        textDecoration: 'underline',
        cursor: "pointer",
        '&:hover': {
            color: theme.palette.primary.dark,
        },
    },
    customTitle: {
        '&$title': {
            fontSize: '1rem',
        }
    },
    monthBody: {
        minWidth: 'auto',
    },
    monthHeader: {
        minWidth: 'auto',
    },
    monthCell: {
        // height: 'auto',
    },
    layoutTooltip: {
        [theme.breakpoints.down('xs')]: {
            '& .MuiPopover-paper': {
                width: 'calc(100% - 32px) !important',
            },
        }
    },
    saveBtnForm: {
        borderRadius: theme.spacing(1),
        padding: `10px ${theme.spacing(6)}px`,
        marginTop: theme.spacing(2),
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        display: 'inline-block',
        "&:hover": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.dark,
        }
    },
    linkBtn: {
        borderRadius: theme.spacing(1),
        "&:hover": {
            color: theme.palette.common.white,
            backgroundColor: 'inherit',
        }
    },
    headerContainer: {
        alignItems: 'center',
    },

    content: {
        padding: theme.spacing(2, 1),
        paddingTop: 0,
        backgroundColor: theme.palette.background.paper,
        boxSizing: 'border-box',
        width: '400px',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    contentContainer: {
        paddingBottom: theme.spacing(1.5),
    },
    text: {
        ...theme.typography.body2,
        display: 'inline-block',
        padding: 0,
    },
    title: {
        ...theme.typography.h6,
        color: theme.palette.text.primary,
        fontWeight: 500,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
    },
    icon: {
        verticalAlign: 'middle',
    },
    contentItemIcon: {
        textAlign: 'center',
    },
    grayIcon: {
        color: theme.palette.action.active,
    },
    colorfulContent: {
        color: theme.palette.primary.main,
    },
    callToActionBtn: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.grey[50],
    },
    lens: {
        width: theme.spacing(4.5),
        height: theme.spacing(4.5),
        verticalAlign: 'super',
    },
    textCenter: {
        textAlign: 'center',
    },
    dateAndTitle: {
        lineHeight: 1.1,
    },
    spaker: {
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        fontWeight: 500,
        '& p': {
            fontWeight: 500,
        }
    },
    description: {
        lineHeight: 1.20,
        display: 'flex',
        flexDirection: 'column',
        '& p': {
            fontWeight: 500,
        }
    },
    titleContainer: {
        paddingBottom: theme.spacing(2),
    },
    container: {
        paddingBottom: theme.spacing(1.5),
    },
        line: {
      height: '2px',
      borderTop: `2px ${theme.palette.primary.main} dotted`,
      width: '100%',
      transform: 'translate(0, -1px)'
    },
    circle: {
      width: theme.spacing(1.5),
      height: theme.spacing(1.5),
      borderRadius: '50%',
      transform: 'translate(-50%, -50%)',
      background: theme.palette.primary.main
    },
    nowIndicator: {
      position: 'absolute',
      zIndex: 1,
      left: 0,
      top: props.top
    },
    shadedCell: {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.12)
      },
      '&:focus': {
        backgroundColor: alpha(theme.palette.primary.main, 0.2),
        outline: 0
      }
    },
    shadedPart: {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      position: 'absolute',
      height: props.shadedHeight,
      width: '100%',
      left: 0,
      top: 0,
      'td:focus &': {
        backgroundColor: alpha(theme.palette.primary.main, 0.12)
      }
    },
    appointment: {
    width: '100%',
      '&:hover': {
        backgroundColor: grey[400]
      }
    },
    shadedAppointment: {
      '&:hover': {
        backgroundColor: grey[500]
      }
    },
})

export default calendarStyles;